import React, { useRef, useEffect, useState } from "react";
import { BsExclamationCircle } from "react-icons/bs";
import "bootstrap/js/dist/tooltip";
import { GoInfo } from "react-icons/go";
// import { Tooltip } from "bootstrap";

import questionMark from "assets/images/question-mark.svg";
import captain from "assets/images/captain.svg";
import underboss from "assets/images/underboss.svg";
import Tooltip from "components/Tooltip/Tooltip";
import { SMOKER_GUY } from "src/constants/images";
import SkillUpgradeModal from "components/Modals/SkillUpgradeModal";
import { replaceFloatValue } from "utils/replaceFloatValue";

const Stats = ({
  nextLevel,
  previousLevel,
  previousLevelName,
  nextLevelName,
}) => (
  <div className="stat mt-1 d-flex justify-content-between align-items-center pb-1">
    <div className="w-100">
      <div className="progress-value d-flex justify-content-between px-2">
        <p className="first mb-0 d-flex justify-content-between">
          <span>{previousLevel}</span>
        </p>
        <p className="second mb-0 d-flex justify-content-between">
          <span></span>
          <span>{nextLevel}</span>
        </p>
      </div>
      <div class="progress individual-progress position-relative">
        <div
          class="progress-bar"
          role="progressbar"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: "100%" }}
        ></div>
      </div>

      <div className="role d-flex justify-content-between px-2">
        <span>{previousLevelName}</span>
        <span>{nextLevelName}</span>
      </div>
    </div>
  </div>
);

const GangstaStatus = ({
  data,
  handleUpgradeSkill,
  address,
  loginWithIcon,
  nftData,
  nftId,
  claimAccumulatedGbet,
  upgradeModal,
  setUpgradeModal,
  salePrice,
  gbetInWallet,
}) => {
  const progressBarRef = useRef(null);

  useEffect(() => {
    if (!data && !ProgressBarRef.current) return;

    const value =
      parseInt(nftData.currentExp) / parseInt(nftData?.nextLevelExp);

    const floatValue = replaceFloatValue(value);
    if (!isNaN(floatValue) && isFinite(floatValue)) {
      progressBarRef.current.style.width = replaceFloatValue(value * 100) + "%";
    } else {
      progressBarRef.current.style.width = 0 + "%";
    }
  }, [data]);

  const handleUpgrade = () => {
    setUpgradeModal(true);
    if (!address) {
      loginWithIcon();
    } else {
      setUpgradeModal(true);
    }
  };

  const handleConfirmSkillUpgrade = (payload) => {
    setUpgradeModal(false);
    handleUpgradeSkill(payload);
  };

  const calculateSkillPercentage = () => {
    const value =
      parseInt(nftData.currentExp) / parseInt(nftData?.nextLevelExp);

    const floatValue = replaceFloatValue(value * 100);

    return (floatValue != "NaN" ? floatValue : 0) + "%";
  };

  const getNextClosestStatPercentage = (current, nextLevel, increaseBy) => {
    let value = parseInt(current) / parseInt(nextLevel);
    let per =
      value * 100 + increaseBy >= 100
        ? 100
        : replaceFloatValue((value * 100) / 10) * 10 + increaseBy;
    return per;
  };

  return (
    <div className="gp-gangsta-status">
      <div className="card-stat">
        <div className="stats-containers mb-4">
          <div className="stats">
            <p className="mb-0 title current">Current Stats</p>
            <p className="value mb-0 mt-1">
              {parseInt(nftData?.currentExp)
                ? parseInt(nftData?.currentExp)
                : 0}
              <span className="ms-1">(total)</span>
            </p>
          </div>
          <div className="stats">
            <div className="position-relative text-center d-block view-all-stats-container">
              <div
                className={`view-all-stats ${
                  address !== nftData.owner && salePrice == -1 ? "no-stats" : ""
                } position-absolute`}
              ></div>
              <p className="mb-0 title level d-flex">
                <span style={{ paddingRight: "2px" }}>Level</span>{" "}
                {/* <span className="custom-tooltip">
                  <span className="tooltiptext">This is some information.</span>
                  <GoInfo
                    color="var(--secondary-color)"
                    className="info-icon"
                  />
                </span> */}
              </p>
            </div>

            <p className="value mb-0 mt-1">{nftData?.levelTitle}</p>
          </div>
        </div>
        <div className="stat mt-1 d-flex justify-content-between align-items-center">
          <div className="w-100">
            <div className="progress-value d-flex justify-content-between px-2">
              <p
                className={`${
                  getNextClosestStatPercentage(
                    nftData.currentExp,
                    nftData?.nextLevelExp,
                    0
                  ) >= 90
                    ? "third"
                    : "first"
                } current-stat mb-0 d-flex justify-content-between`}
                style={{
                  width: `${getNextClosestStatPercentage(
                    nftData.currentExp,
                    nftData?.nextLevelExp,
                    0
                  )}%`,
                }}
              >
                <span></span>
                <span>
                  {`${Number(
                    getNextClosestStatPercentage(
                      nftData.currentExp,
                      nftData?.nextLevelExp,
                      0
                    )
                  ).toFixed(2)}%`}
                </span>
              </p>

              {getNextClosestStatPercentage(
                nftData.currentExp,
                nftData?.nextLevelExp,
                0
              ) >= 90 ? null : (
                <p
                  className="third mb-0 d-flex justify-content-between"
                  style={{
                    width: "100%",
                  }}
                >
                  <span></span>
                  <span>100%</span>
                </p>
              )}
            </div>
            <div class="progress individual-progress position-relative">
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
                ref={progressBarRef}
              ></div>
            </div>

            <div className="role d-flex justify-content-between px-2">
              <span>{nftData?.levelTitle}</span>
              <span>{nftData?.nextLevelTitle}</span>
            </div>
          </div>
        </div>
        <div className="upgrade-skills mt-2 text-center">
          {address && address === nftData.owner ? (
            <button className="gp-cta blue" onClick={handleUpgrade}>
              Upgrade Skills
            </button>
          ) : null}
          {claimAccumulatedGbet && address === nftData.owner ? (
            <p className=" mb-0 mt-2 claim-information skill-update">
              Please claim accumulated <strong>$GBET</strong> before upgrading
              skills.
            </p>
          ) : (
            ""
          )}
        </div>

        <SkillUpgradeModal
          gbetInWallet={gbetInWallet}
          isVisible={upgradeModal}
          loginWithIcon={loginWithIcon}
          handleUpgradeSkill={handleConfirmSkillUpgrade}
          onClose={() => setUpgradeModal(false)}
          nftData={nftData}
          nftId={nftId}
        />
      </div>
    </div>
  );
};

export default GangstaStatus;
